import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import MuiSwitch from '@material-ui/core/Switch';
import MuiFormControlLabel from '@material-ui/core/FormControlLabel';
// Internal
import { getMuiColor } from './internal/Tools';

const Switch = ({
  label, labelPlacement, checked, primary, secondary, disabled, edge, size, onChange,
}) => {
  // MUI color
  const color = getMuiColor(primary, secondary);

  // Change handler
  const handleChange = onChange ? (e) => onChange(e.target.checked) : null;

  // Components props
  const formControlLabelProps = { label, labelPlacement };
  const switchProps = {
    checked, color, disabled, edge, size, onChange: handleChange,
  };

  return (
    <MuiFormControlLabel
      {...formControlLabelProps}
      control={
        <MuiSwitch {...switchProps} />
      }
    />
  );
};

Switch.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  labelPlacement: PropTypes.oneOf(['top', 'start', 'bottom', 'end']),
  checked: PropTypes.bool.isRequired,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  disabled: PropTypes.bool,
  edge: PropTypes.oneOf(['start', 'end']),
  size: PropTypes.oneOf(['medium', 'small']),
  onChange: PropTypes.func,
};

Switch.defaultProps = {
  label: null,
  labelPlacement: 'end',
  primary: true,
  secondary: false,
  disabled: false,
  edge: null,
  size: null,
  onChange: null,
};

export default React.memo(Switch);



// WEBPACK FOOTER //
// ./components/core/Switch.js